<section class="amenities" id="amenities">
  <div class="amenities-header">
    <div class="reveal">
      <p class="section-label">Crafted for Extraordinary Living</p>
      <h2 class="amenities-title">
        The<br>Amenities
      </h2>
    </div>
    <p class="amenities-desc reveal reveal-delay-2">
      Every level unfolds like a private resort — from tranquil cafés and garden terraces to rooftop sanctuaries above the clouds.
    </p>
  </div>
  <div class="amenities-grid">
    @for (item of amenities; track item.name; let i = $index) {
      <div class="amenity-card reveal" [class]="'amenity-card reveal reveal-delay-' + ((i % 4) + 1)">
        <span class="amenity-icon" aria-hidden="true">
          @switch (item.icon) {
            @case ('restaurant') {
              <svg viewBox="0 0 64 64" fill="none">
                <path d="M18 10v18c0 4 3 7 7 7v19M31 10v18c0 4-3 7-7 7M24 10v25" />
                <path d="M44 10c5 5 5 14 0 19v25M44 10v44" />
              </svg>
            }
            @case ('pool') {
              <svg viewBox="0 0 64 64" fill="none">
                <path d="M12 18h40M16 28h32" />
                <path d="M12 40c5 0 5 4 10 4s5-4 10-4 5 4 10 4 5-4 10-4" />
                <path d="M12 50c5 0 5 4 10 4s5-4 10-4 5 4 10 4 5-4 10-4" />
              </svg>
            }
            @case ('spa') {
              <svg viewBox="0 0 64 64" fill="none">
                <path d="M32 47c-8 0-12-5-12-11 0-8 7-12 12-20 5 8 12 12 12 20 0 6-4 11-12 11Z" />
                <path d="M20 28c-5-1-9-5-9-10 6 0 11 4 12 9M44 28c5-1 9-5 9-10-6 0-11 4-12 9" />
              </svg>
            }
            @case ('garden') {
              <svg viewBox="0 0 64 64" fill="none">
                <path d="M32 54V22" />
                <path d="M32 24c-10 0-16-6-16-16 10 0 16 6 16 16Z" />
                <path d="M32 32c10 0 16-6 16-16-10 0-16 6-16 16Z" />
                <path d="M32 42c-8 0-13-5-13-13 8 0 13 5 13 13Z" />
              </svg>
            }
            @case ('gym') {
              <svg viewBox="0 0 64 64" fill="none">
                <path d="M14 24v16M22 20v24M42 20v24M50 24v16" />
                <path d="M22 32h20" />
                <path d="M10 28h4v8h-4zM50 28h4v8h-4zM18 24h4v16h-4zM42 24h4v16h-4z" />
              </svg>
            }
            @case ('retail') {
              <svg viewBox="0 0 64 64" fill="none">
                <path d="M14 24h36v28H14z" />
                <path d="M20 24v-6c0-6 4-10 12-10s12 4 12 10v6" />
                <path d="M24 34h16M24 42h16" />
              </svg>
            }
            @case ('play') {
              <svg viewBox="0 0 64 64" fill="none">
                <path d="M18 48V26M46 48V26M18 26l14-12 14 12" />
                <path d="M24 48V34M40 48V34M24 34h16" />
              </svg>
            }
            @case ('lounge') {
              <svg viewBox="0 0 64 64" fill="none">
                <path d="M18 34h28c6 0 8 3 8 8v6H10v-6c0-5 2-8 8-8Z" />
                <path d="M18 34V22c0-5 3-8 7-8h14c4 0 7 3 7 8v12" />
                <path d="M14 48v6M50 48v6" />
              </svg>
            }
          }
        </span>
        <div class="amenity-name">{{ item.name }}</div>
        <div class="amenity-desc">{{ item.desc }}</div>
      </div>
    }
  </div>

  <!-- Amenities slider -->
  <div class="amenities-slider-wrap reveal reveal-delay-2">
    <swiper-container
      #swiperEl
      class="amenities-slider"
      slides-per-view="1"
      space-between="0"
      centered-slides="true"
      rewind="true"
      grab-cursor="true"
      speed="900"
      [pagination]="pagination"
      [autoplay]="autoplay"
      [breakpoints]="breakpoints"
    >
      @for (slide of slides; track slide.src) {
        <swiper-slide>
          <article class="am-card">
            <div class="am-media">
              <button type="button" class="am-media-hit" (click)="openAt($index, $event)" aria-label="View fullscreen"></button>
              <button type="button" class="am-expand-btn" (click)="openAt($index, $event)" aria-label="Expand">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M7 17L17 7M17 7H10M17 7v7"/>
                  <path d="M7 17H14M7 17v-7"/>
                </svg>
              </button>
              <img [src]="slide.src" [alt]="slide.label" class="am-image" loading="lazy" />
            </div>
            <div class="am-meta">
              <div class="am-step"><span class="am-step-line"></span></div>
              <div class="am-text">
                <h3>{{ slide.category }}</h3>
                <p>{{ slide.label }}</p>
              </div>
            </div>
          </article>
        </swiper-slide>
      }
    </swiper-container>

    <div class="am-nav">
      <button class="am-nav-btn am-nav-prev" (click)="prevSlide()" aria-label="Previous">
        <div class="am-nav-ring"></div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M11 14L6 9l5-5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <button class="am-nav-btn am-nav-next" (click)="nextSlide()" aria-label="Next">
        <div class="am-nav-ring"></div>
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M7 4l5 5-5 5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>

  <div #lgContainer style="display:none"></div>

  <div class="amenities-wildlife reveal reveal-delay-2">
    <div class="wildlife-marquee" aria-hidden="true">
      <div class="wildlife-marquee-track">
        <img src="/silhouette.png" alt="" class="wildlife-image" />
        <img src="/silhouette.png" alt="" class="wildlife-image" />
        <img src="/silhouette.png" alt="" class="wildlife-image" />
        <img src="/silhouette.png" alt="" class="wildlife-image" />
      </div>
    </div>
  </div>
</section>
